"use strict";
//Polish
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Wkład',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Wydajność',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Anuluj',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Zapisać',
  'BACK-BTN-LABEL': 'Plecy',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Niemy',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Trzymać',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Klawiatura',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Transfer',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Nowe połączenie',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Odłożyć słuchawkę',
  'CALLLIST-NOCALL' : 'Brak aktywnego połączenia',
  'CANCEL-BTN-LABEL' : 'Anuluj',
  'EMAIL-PLACEHOLDER' : 'adres e-mail',
  'INCOMINGCALL-HEADER' : 'Połączenie przychodzące',
  'INCOMINGCALL-ACCEPT' : 'Zaakceptować',
  'INCOMINGCALL-DECLINE' : 'upadek',
  'INCOMINGCALL-VOICEMAIL' : 'Wyślij do poczty głosowej',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Wprowadź adres e-mail',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'Wprowadź hasło',
  'LOGIN-CHECKBOX-LABEL' : 'Zapamiętaj mnie',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Zapomniałeś hasła?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Zaloguj',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Wpisz swój adres e-mail, aby zresetować hasło.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Proszę podać pełną hasło',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Proszę podać poprawny adres e-mail',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Hasło musi pasować',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'nastawić',
  'LOGIN-RESETPW-INFO-TEXT' : ', Prosimy o zmianę hasła. Hasło powinno zawierać co najmniej jedną literę, bez białej przestrzeni, a nie zaczynać @, i 8 lub więcej znaków.',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Nowe hasło',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'Powtórz hasło',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Zmiana',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Anuluj',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Zobacz Alerts',
  'SETTINGS-VERSION' : 'wersja ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Pomoc Dokumentacja',
  'SETTINGS-CHECKBOX-LABEL' : 'Włączyć',
  'SETTINGS-CHECKBOX-HEADER' : 'Zawsze na górze?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Zamknij Alerts',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Wyloguj',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Rozbudowa',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Dzwonek',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Urządzenie Wejściowe',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Urządzenie Wyjściowe',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Sterowanie nimie',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Język interfejsu',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Plecy',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Jasny',
  'CALLHISTORY-HEADER' : 'Historia',
  'CALLHISTORY-NO-HISTORY-MSG' : 'No Historia połączeń',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Ustawienia',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'jasny',
  'ALERTLOG-HEADER' : 'Powiadomienia',
  'ALERTLOG-NO-ALERT-MSG' : 'Brak dostępnych alarmy',
  'UTILITIES-STATUS-ONHOLD' : 'W oczekiwaniu',
  'UTILITIES-STATUS-MUTED' : 'wyciszony',
  'UTILITIES-STATUS-ACTIVE' : 'Aktywny',
  'UTILITIES-STATUS-DIALING' : 'wybieranie',
  'ALERTITEM-HEADING-LOGIN' : 'Zaloguj Się',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Nazwa użytkownika lub hasło jest nieprawidłowe.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Utracone połączenie sieciowe. Sprawdź stan połączenia.',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Wprowadź numer zadzwonić',
  'CALLDETAILS-HOLD' : 'W oczekiwaniu',
  'CALLDETAILS-MUTED': 'wyciszony',
  'CALLLIST-STATUS-ACTIVE': 'Aktywny',
  'CALLLIST-STATUS-DIALING': 'wybieranie',
  'CALLHISTORY-STATUS-FAILED': 'Niepowodzenie',
  'HEADING-STATUS-CONNECTED' : 'Połączony',
  'HEADING-STATUS-OFFLINE' : 'Autonomiczny',
  'BLIND-BTN-LABEL': 'Ślepy',
  'ATTENDED-BTN-LABEL': 'Uczęszczany',
  'SOFTPHONE-DTMF-COMMANDS': "Wpisz numer",
  'ARIA-LOGIN-SIGNIN-BTN': "Zaloguj się przyciskiem",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "Zapomniałeś hasła Przycisk",
  'ARIA-CANCEL-BTN': "przycisk Anuluj",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "Przycisk resetowania hasła",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Nie teraz przycisk",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Przycisk powrotu',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Przycisk Wyczyść historię',
  'ARIA-SETTINGS-LOGOUT-BTN': "przycisk Wyloguj",
  'ARIA-SETTINGS-VIEWALERT-BTN': "Przycisk View alarmy",
  'ARIA-SETTINGS-HELPDOC-BTN': "Przycisk pomocy dokumentacji",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "Przycisk Zmień hasło",
  'ARIA-BACKSPACE-BTN': 'przycisk Backspace',
  'ARIA-DIALING-INPUT-FIELD': 'Pole wejściowe wybieranie',
  'ARIA-HEADER': 'nagłówek',
  'ARIA-CLEAR-ALERTS-BUTTON': 'Przycisk Usuń alarmy',
  'ARIA-ALERT-LIST': 'ista alertów',
  'ARIA-CHECKBOX': 'pole wyboru',
  'ARIA-SAVE-BTN': 'przycisk Zapisz',
  'ARIA-INPUT-FIELD': 'pole tekstowe',
  'ARIA-INPUT': 'Wkład',
  'ARIA-KEYPAD': 'klawiatura',
  'ARIA-KEY': 'Klawisz',
  'ARIA-AUDIO-SLIDER': 'suwak audio',
  'ARIA-AUDIO-SLIDER-CONTROL': 'Sterowanie systemem audio Suwak',
  'ARIA-MENU-ITEM': 'Pozycja w menum',
  'ARIA-DROP-DOWN-MENU': 'Rozwijanego menu',
  'ARIA-BADGE-BUTTON': 'odznaka',
  'ARIA-CALL-DETAIL': 'Zaproszenie detal',
  'ARIA-OPEN-SETTINGS-BUTTON': 'Przycisk Otwórz ustawienia',
  'UPDATE-HEADER': 'Dostępna aktualizacja',
  'UPDATE-MSG': 'Czy chciałbyś, aby ponownie uruchomić aplikację teraz?',
  'UPDATE-POSTPONE-BUTTON': 'Odłożyć (1 min)',
  'UPDATE-UPDATE-BUTTON': 'Aktualizacja',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'przycisk odroczyć',
  'ARIA-UPDATE-UPDATE-BUTTON': 'aktualizacja Przycisk',
  'ACTIVECALL-STATUS-RINGING': 'Dzwonienie',
  'ACTIVECALL-STATUS-ACTIVE': 'Aktywny',
  'ACTIVECALL-STATUS-DIALING': 'wybieranie',
  'ACTIVECALL-STATUS-FAILED': 'Niepowodzenie',
  'LOGIN-INPUT-SHOW': 'Pokazać',
  'LOGIN-INPUT-HIDE': 'Ukryć',
  'CALLHISTORY-TODAY': 'Dzisiaj',
  'CALLHISTORY-YESTERDAY': 'Wczoraj',
  'ALERT_FORGOT_PASSWORD': 'Zapomniałeś hasła',
  'ALERT_SETTINGS_WILL_APPLY': 'Połączenia czynnej; ustawienia będą stosowane w trybie bezczynności.',
  'ALERT_DIALING_OPTIONS': 'Opcje wybierania',
  'ALERT_DIALING_OPTIONS_BODY': 'Brakujące opcje planu wybierania numerów',
  'ALERT_LOGIN': 'Zaloguj Się',
  'ALERT_SOFTPHONE_EXTENSION': 'Przedłużenie softphone',
  'ALERT_MORE_INFORMATION': 'Aby uzyskać więcej informacji na stronie:',
  'ALERT_LOST_CONNECTION': 'Utracone połączenie sieciowe. Sprawdź stan połączenia.',
  'ARIA-PLAY-BTN': 'przycisk play',
  'ARIA-STOP-BTN': 'przycisk stop',
  'CONTACTS-STATUS-ONLINE': 'Online',
  'CONTACTS-STATUS-OFFLINE': 'Offline',
  'CONTACTS-STATUS-BUSY': 'Zajęty',
  'CONTACTS-STATUS-UNKNOWN': 'Nieznany',
  'LABELLEDINPUT-LABEL-EMAIL': "adres e-mail",
  'LABELLEDINPUT-LABEL-PASSWORD': "Hasło",
  'LABELLEDINPUT-LABEL-TEXT': "Tekst",
  'LABELLEDINPUT-HINT-EMAIL': "Wprowadź poprawny adres e-mail poniżej.",
  'LABELLEDINPUT-HINT-PASSWORD': "Podaj poprawne hasło poniżej.",
  'LABELLEDINPUT-HINT-TEXT': "Wpisz tekst poniżej.",
  'ARIA-ICON-AREA': 'Ikona Area',
  'SETTINGS-ADVANCED-LOGGING': "Zaawansowane rejestrowanie",
  'APPMENU-SETTINGS-BTN-LABEL': "Otwórz ustawienia",
  'APPMENU-HELP-BTN-LABEL': "Dokumentacja pomocy",
  'APPMENU-LOGOUT-BTN-LABEL': "Wyloguj",
  'APPMENU-VERSION': "wersja ",
  'HEADER-SETTINGS-TITLE': "Ustawienia",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Powiadomienia",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Wygląd",
  'SETTINGS-CONTACTS-BTN-LABEL': "Łączność",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Rozwiązywanie problemów",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Dostosuj sposób otrzymywania aktualizacji.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Zmień wygląd i wygląd aplikacji.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importuj kontakty.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Narzędzia, które pomogą Ci zrozumieć, co jest nie tak",
  'ARIA-BACK-BTN-LABEL': "Plecy",
  'HEADER-BACK-ARIA-LABEL' : 'z powrotem',
  'ENTITYLIST-SEARCH-FOUND': "uznany.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "przedmiotów",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Nowa grupa',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Nie znaleziono kontaktów',
  'ENTITYLIST-TRY-IMPORTING': 'Spróbuj importować lub dodać.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Import',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Wprowadź numer, z którego chcesz wysłać lub zaimportować listę kontaktów w ustawieniach.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Szukaj kontaktów",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Dodaj numer',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Brak informacji kontaktowych',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Dodaj numer, aby rozpocząć',
  'ARIA-CARD-DETAILS-EDIT': 'Edytować',
  'ARIA-CARD-DETAILS-DELETE': 'Kasować',
  'SETTINGS-DEVICES-BTN-LABEL': "Pomysłowość",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Zmień sposób konfiguracji urządzeń.",
  'HEADER-CONTACTS-ARIA-LABEL' : "łączność",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Rozwiązywanie problemów",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Włącz zaawansowane rejestrowanie",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Po włączeniu aplikacja utworzy zaawansowane dzienniki, aby pomóc w diagnozowaniu błędów aplikacji.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Zaawansowane Rejestrowanie',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Alerty",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Wyświetl Alerty",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Uzyskaj dostęp do rejestru alertów i dzienników.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Dzwonek",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Zmień dźwięk dzwonka przychodzących połączeń głosowych.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Zaniedbanie",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Lekki",
  'APPMENU-DARK-THEME-BTN-LABEL': "Ciemny",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Zawsze na górze",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Po włączeniu aplikacja będzie zawsze wyświetlana nad innymi aplikacjami.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Zawsze na górze?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Motyw",
  'SETTINGS-THEMES-DESCRIPTION': "Tematy zmieniają ogólny wygląd aplikacji.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Język",
  'SETTINGS-LANGUAGE-DESCRIPTION': "Zmiana języka zmienia się w całym programie.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Urządzenie",
  "SETTINGS-CATEGORY-HEADER-NOTIFICATIONS" : "Powiadomienia",
  "SETTINGS-CATEGORY-HEADER-APPEARANCE" : "Wygląd",
  "SETTINGS-CATEGORY-HEADER-CONTACTS" : "Łączność",
  'SETTINGS-INPUT-DEVICE-TITLE': "Urządzenie wejściowe",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Ustaw urządzenie audio, którego chcesz używać.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Urządzenie wyjściowe",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Ustaw urządzenie audio, z którego chcesz korzystać.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importuj kontakty",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Wybierz opcję poniżej, aby zaimportować kontakty.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Przykładowe CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Naciśnięcie przycisku poniżej spowoduje pobranie przykładowego pliku CSV.",
  'SETTINGS-CONTACTS-BACKUP': 'Utworzyć kopię zapasową',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Naciśnięcie przycisku poniżej spowoduje pobranie kopii zapasowej Twoich kontaktów przez CSV. Jest to zalecane przed importem.",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Pobierz próbkę',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Importowany",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Import",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Pobierz kopię zapasową',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Dodaj kontakt',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Anuluj",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Kasować",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Czy na pewno chcesz usunąć ten kontakt?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Zakończenie tej akcji spowoduje trwałe usunięcie bieżących informacji o kontakcie. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Pole w poniższym formularzu ma błąd.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Informacje osobiste',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Pierwsze imię',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Wprowadź imię',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Nazwisko',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Wpisz nazwisko',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Firma',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Wprowadź nazwę firmy',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Numery telefoniczne',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Dodaj telefon',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Anuluj',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Zapisać',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Nowy kontakt',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Edytuj kontakt',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'To pole nie może być puste.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Numer',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Podaj poprawny 10-cyfrowy numer',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Wpisz numer...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Korzystne?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Dom',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Biznes',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'mobilny',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Inny',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Etykieta',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Wybierz numer do połączenia',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Korzystne',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Podaj poprawny numer'

};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-pl.js